// SystemSubsystem.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./SystemSubsystem";

import bombShell from "../Assessts/Products images/1Frangible.jpg";
import universalTestRig from "../Assessts/Products images/2firing.jpg";
import controlValve from "../Assessts/Products images/3proximity.jpg";
import oxygenVehicle from "../Assessts/Products images/4klaxon.jpg";
import nitrogenVehicle from "../Assessts/Products images/5hydrostatic.jpg";
import snubberTest from "../Assessts/Products images/ELT_NEW.png";

import Grips from "../Assessts/Products images/7Grips.png";
import rips from "../Assessts/Products images/8rips.jpg";
import harness from "../Assessts/Products images/9harness.jpg";
import spm from "../Assessts/Products images/10spm.jpg";
import back from "../Assessts/Products images/11back.jpg";
import convertor from "../Assessts/Products images/12convertor.jpg";

import tech from "../Assessts/Products images/13tech.jpg";
import ir from "../Assessts/Products images/14IR.jpg";
import assembly from "../Assessts/Products images/15assembly.jpg";
import dha from "../Assessts/Products images/16dha.jpg";
import rugged from "../Assessts/Products images/17rugged.jpg";
import c from "../Assessts/Products images/18c.jpg";
import d from "../Assessts/Products images/19.jpg";
import e from "../Assessts/Products images/20.jpg";
import f from "../Assessts/Products images/21.jpg";


const products = [
  {
    id: 1,
    title: "FRANGIBLE SWITCH",
    img: bombShell,
    desc: "Frangible switches are designed to break under carefully defined conditions, providing a controlled safety mechanism. They play a critical role in ensuring the protection of sensitive systems during emergencies or testing scenarios. By eliminating uncontrolled damage, these switches safeguard equipment while maintaining operational reliability.",
  },
  {
    id: 2,
    title: "BRIDGE FIRING BOX ASSEMBLY",
    img: universalTestRig,
    desc: "The Bridge Firing Box Assembly offers a robust and reliable ignition solution for aerospace and defense applications. Built with advanced safety measures, it ensures precise control during test firings. Its durable construction and dependable performance make it ideal for high-stakes environments where safety is paramount.",
  },
  {
    id: 3,
    title: "PROXIMITY SWITCH ASSEMBLY",
    img: controlValve,
    desc: "Proximity Switch Assemblies are engineered for accurate detection of presence or position in mission-critical operations. They ensure seamless automation and reliability even in extreme aerospace and defense conditions. With precision engineering, these switches deliver consistent performance under pressure.",
  },
  {
    id: 4,
    title: " MIL RUGGED HORN",
    img: oxygenVehicle,
    desc: "Klaxon Horns are designed to deliver loud, clear, and dependable warning signals across aircraft, naval, and defense systems. Built to perform in demanding environments, they ensure alerts are heard in time-critical situations. Their rugged build provides long-term reliability and minimal maintenance needs.",
  },
  {
    id: 5,
    title: "HYDROSTATIC SWITCH",
    img: nitrogenVehicle,
    desc: "Hydrostatic Switches are built to accurately monitor and control hydraulic and pneumatic pressure systems. They provide early warnings against irregular pressure fluctuations, preventing potential system failures. These switches offer unmatched reliability for both defense and aerospace hydraulic applications.",
  },
  {
    id: 6,
    title: "ELT SYSTEMS",
    img: snubberTest,
    desc: "Emergency Locator Transmitter (ELT) Systems are vital for quick distress signaling during emergencies. They are engineered for rapid deployment and long-distance signal accuracy to support search-and-rescue missions. Rugged and dependable, these systems ensure safety in mission-critical aerospace operations.",
  },
  {
    id: 7,
    title: "CONTROL WHEELS & GRIPS",
    img: Grips,
    desc: "Aircraft Control Wheels and Grips are designed with ergonomic precision to enhance pilot comfort and handling. They integrate functionality with ease of control for mission-critical maneuvering. Built for durability, these assemblies withstand long operational hours without compromising performance.",
  },
  {
    id: 8,
    title: "RECORDER INDEPENDENT POWER SUPPLY",
    img: rips,
    desc: "The Recorder Independent Power Supply (SSDR Power Supply) provides stable backup power for recording and monitoring systems.It operates independently of the main source, ensuring uninterrupted performance during outages.Compact and efficient, it safeguards data integrity and system reliability.",
  },
  {
    id: 9,
    title: "CABLE HARNESS",
    img: harness,
    desc: "Cable Harnesses are engineered for durability and integration into aerospace and defense electrical systems. They are designed to manage complex wiring needs while minimizing space and weight. Custom-built solutions ensure seamless connectivity and high-performance under demanding environments.",
  },
  {
    id: 10,
    title: "SHIFTING & LOADING SPM",
    img: spm,
    desc: "Special Purpose Machines (SPM) for shifting and loading are tailored to defense manufacturing requirements. They streamline heavy-duty processes with precision and reliability. Engineered for high efficiency, these machines enhance productivity while reducing manual risks.",
  },
  {
    id: 11,
    title: "LOAD BANK",
    img: back,
    desc: "Load Banks are designed to simulate electrical loads for testing, calibration, and validation. They ensure power systems function reliably before deployment in mission-critical environments. With rugged construction, they provide safe and consistent testing performance for defense and aerospace applications.",
  },
  {
    id: 12,
    title: "AC/DC CONVERTER",
    img: convertor,
    desc: "RF Ac/Dc Converters enable efficient frequency translation for secure communication and radar systems. Built for precision and low-noise performance, they support seamless data transmission. Their rugged design ensures reliability in both defense and aerospace operations.",
  },
  {
    id: 13,
    title: "TEST BENCH",
    img: tech,
    desc: "Test Benches provide comprehensive platforms for validating aerospace and defense components. They simulate real-world conditions to ensure equipment reliability and safety. Custom-designed solutions offer versatility and precision for critical testing needs.",
  },
  {
    id: 14,
    title: "CUSTOMISED VISION SYSTEM",
    img: ir,
    desc: "Customized Vision Systems combine infrared and optical technology for advanced monitoring. They are tailored for surveillance, targeting, and defense-specific applications. Built with precision optics, these systems enhance situational awareness in critical operations.",
  },
  {
    id: 15,
    title: "PCB ASSEMBLY",
    img: assembly,
    desc: "PCB Assemblies are manufactured to aerospace-grade standards for mission-critical electronics. They ensure reliable performance under extreme conditions with superior quality assurance. Each assembly is tailored to meet stringent defense and aviation requirements.",
  },
  {
    id: 16,
    title: "DISPLAY HEAD ASSEMBLY",
    img: dha,
    desc: "Display Head Assemblies provide real-time visualization and control for pilots and operators. They integrate advanced display technology to enhance decision-making in fast-paced environments. Designed for durability, they ensure seamless performance in defense applications.",
  },
  {
    id: 17,
    title: "RUGGED ETHERNET SWITCH & ROUTERS",
    img: rugged,
    desc: "Military-grade Ethernet Switches and Routers enable high-speed, secure communication in mission-critical systems. They are engineered to function in harsh and extreme environments without failure. With advanced security features, they support uninterrupted defense operations.",
  },
  {
    id: 18,
    title: "RUGGED PANEL PC",
    img: c,
    desc: "Rugged Panel PCs are built for extreme environmental conditions while offering high computing power. They ensure uninterrupted performance in mission-critical defense and aerospace operations. With robust design, they withstand dust, vibration, and temperature fluctuations.",
  },
  {
    id: 19,
    title: "RF RECORD/PLAYBACK SYSTEM",
    img: d,
    desc: "RF Record and Playback Systems allow accurate capturing and simulation of radio frequency signals. They support testing, mission rehearsal, and post-operation analysis with high fidelity. Built for precision, they ensure reliable performance in complex communication environments.",
  },
  {
    id: 20,
    title: "MARINE PANEL PC",
    img: e,
    desc: "Marine Panel PCs are ruggedized for naval and offshore applications with waterproof designs. They are resistant to corrosion and built for continuous operation in marine conditions. These systems provide reliable computing power in mission-critical maritime environments.",
  },
  {
    id: 21,
    title: "RUGGED UPS/INVERTER",
    img: f,
    desc: "Rugged UPS and Inverter Systems ensure uninterrupted power supply for aerospace and defense applications. Built to handle voltage fluctuations, they protect sensitive equipment from damage. Their durable design guarantees reliable operation in critical missions and harsh environments.",
  },
];


export default function SystemSubsystem() {
  return (
    <div style={{ background: 
    // "linear-gradient(135deg, rgba(28, 29, 31, 0.95), rgba(255, 255, 255, 0.9))" 
    "white"
    }}>
      <h2
        style={{
          fontWeight: 600,
          textAlign: "center",
          marginBottom: "50px",
          // marginTop: "50px",
          paddingTop:"50px",
          // color:"rgba(14, 14, 69, 0.88)"
          color:"#074f86ff"
        }}
      >
        {/* TRENDING <span>↗</span>
         */}
         OUR PRODUCTS
      </h2>
      <div className="system-grid">
        {products.map((item) => (
          <div className="system-card" key={item.id}>
            <img src={item.img} alt={item.title} style={{ height: "250px", objectFit: "contain" }}/>
            <div className="card-title">{item.title}</div>

            {/* description overlay appears only on hover */}
            <div className="hover-desc">
              <p>{item.desc}</p>
              <Link to={`/viewproduct/${item.id}`} className="view-product-btn">
                View Product
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export { products }; // export products so ProductDetails can use
